import * as S from "./SpecialSessionMolecule.style";
import Image from "next/legacy/image";
import companies from "/public/images/landing/responsibility/special_session.png";

const SpecialSessionMolecule = () => {
  return (
    <S.Wrapper>
      <S.Title>Special Session</S.Title>
      <S.Desc>
        우수 수료생을 위한
        <br />
        네카라쿠배 공채 대비반
      </S.Desc>
      <S.Image>
        <Image
          src={companies}
          alt="companies-img"
          quality={100}
          loading="lazy"
        />
      </S.Image>
      <S.Info>
        뛰어난 퍼포먼스로 수료한 수강생을 대상으로
        <br /> 네카라쿠배 공채 대비반을 진행합니다.
      </S.Info>
      <S.Info>
        스파르타코딩클럽 실무 협업을 통해 대량의 트래픽을 직접 다뤄보고, 그
        외에도 다양한 기회와 함께 담당 멘토진의 밀착관리가 진행됩니다.
      </S.Info>
    </S.Wrapper>
  );
};

export default SpecialSessionMolecule;
